import { render, staticRenderFns } from "./CourseResourceManagement.vue?vue&type=template&id=11d4a823&scoped=true"
import script from "./CourseResourceManagement.vue?vue&type=script&lang=js"
export * from "./CourseResourceManagement.vue?vue&type=script&lang=js"
import style0 from "./CourseResourceManagement.vue?vue&type=style&index=0&id=11d4a823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d4a823",
  null
  
)

export default component.exports